import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnamneseConfiguracaoListarComponent } from './anamnese-configuracao-listar.component';
import { AnamneseConfiguracaoListarRoutingModule } from './anamnese-configuracao-listar-routing.module';
import { TableModule } from 'primeng/table';
import { DividerModule } from 'primeng/divider';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';

@NgModule({
  declarations: [
    AnamneseConfiguracaoListarComponent
  ],
  imports: [
    CommonModule,
    AnamneseConfiguracaoListarRoutingModule,
    TableModule,
    DividerModule,
    ButtonModule,
    InputTextModule,
    MessagesModule,
    ProgressSpinnerModule,
    ConfirmDialogModule
  ],
  providers: [ConfirmationService]
})
export class AnamneseConfiguracaoListarModule { }
